import { useState } from 'react';
import {
  useReactTable,
  createColumnHelper,
  getCoreRowModel,
  getFilteredRowModel,
  flexRender,
} from '@tanstack/react-table';

// Define the data structure
interface Person {
  name: string;
  age: number;
  status: string;
}

// Sample data
const defaultData: Person[] = [
  { name: 'Alice', age: 25, status: 'Active' },
  { name: 'Bob', age: 30, status: 'Inactive' },
  { name: 'Charlie', age: 35, status: 'Pending' },
  { name: 'David', age: 28, status: 'Active' },
  { name: 'Eva', age: 40, status: 'Inactive' },
];

// Create columns using columnHelper
const columnHelper = createColumnHelper<Person>();
const columns = [
  columnHelper.accessor('name', {
    header: 'Name',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('age', {
    header: 'Age',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    cell: info => info.getValue(),
  }),
];
const globalFilterFn = (row: any, columnId: string, filterValue: string) => {
  const terms = filterValue.toLowerCase().split(' ').filter(Boolean);

  const rowString = Object.values(row.original).join(' ').toLowerCase();

  return terms.some(term => rowString.includes(term)); // 👈 OR-based search
};
const SearchableTable = () => {
  const [globalFilter, setGlobalFilter] = useState('');

 const table = useReactTable({
  data: defaultData,
  columns,
  state: { globalFilter },
  onGlobalFilterChange: setGlobalFilter,
  globalFilterFn, // 🔥 add this line
  getCoreRowModel: getCoreRowModel(),
  getFilteredRowModel: getFilteredRowModel(),
});


  return (
    <div style={{ padding: 20 }}>
      <input
        type="text"
        value={globalFilter}
        onChange={e => setGlobalFilter(e.target.value)}
        placeholder="Search across all columns..."
        style={{ marginBottom: '10px', padding: '8px', width: '300px' }}
      />

      <table border={1} cellPadding={8} cellSpacing={0}>
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <th key={header.id}>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map(cell => (
                <td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SearchableTable;
